import * as React from 'react';

import {AccountTags} from './account-tags';
import {ContactTags} from './contact-tags';

import styles from './peep-tags.module.css';

type Props = {
    id: string;
    entityType: 'person' | 'company';
};

export function PeepTags(props: Props) {
    const isAccount = props.entityType === 'company';

    return (
        <div className={styles['tag-container']}>
            {isAccount ? (
                <AccountTags accountId={props.id} />
            ) : (
                <ContactTags contactId={props.id} />
            )}
        </div>
    );
}
